/* Nera³ Luce — paid-traffic landing pages. Vanilla, no libraries.
   Three jobs: entrance motion, the compare slider, and the mobile buy bar.
   Everything here checks prefers-reduced-motion before it moves anything. */
(function () {
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- entrance motion: .ad-rise and ritual steps ---- */
  function reveal() {
    var els = document.querySelectorAll('.ad-rise, .ad-step');
    if (REDUCED || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  /* ---- compare slider ---- */
  function compare(root) {
    var handle = root.querySelector('.ad-compare__handle');
    if (!handle) return;
    var swept = false;

    function set(pct, announce) {
      pct = Math.max(0, Math.min(100, pct));
      root.style.setProperty('--ad-split', pct + '%');
      handle.setAttribute('aria-valuenow', Math.round(pct));
      if (announce) handle.setAttribute('aria-valuetext', Math.round(pct) + '% healthy strand shown');
    }
    function fromClientX(x) {
      var r = root.getBoundingClientRect();
      set(((x - r.left) / r.width) * 100, true);
    }
    var dragging = false;
    function down(e) { dragging = true; root.setPointerCapture && e.pointerId != null && root.setPointerCapture(e.pointerId); fromClientX(e.clientX != null ? e.clientX : e.touches[0].clientX); }
    function move(e) { if (!dragging) return; fromClientX(e.clientX != null ? e.clientX : e.touches[0].clientX); }
    function up() { dragging = false; }

    root.addEventListener('pointerdown', down);
    root.addEventListener('pointermove', move);
    window.addEventListener('pointerup', up);
    root.addEventListener('click', function (e) { if (!dragging) fromClientX(e.clientX); });

    handle.addEventListener('keydown', function (e) {
      var now = parseFloat(handle.getAttribute('aria-valuenow')) || 50;
      var step = e.shiftKey ? 10 : 4;
      if (e.key === 'ArrowLeft') { set(now - step, true); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { set(now + step, true); e.preventDefault(); }
      else if (e.key === 'Home') { set(0, true); e.preventDefault(); }
      else if (e.key === 'End') { set(100, true); e.preventDefault(); }
    });

    /* one slow sweep the first time it is seen, so the interaction is discoverable */
    function sweep() {
      if (swept || REDUCED) return;
      swept = true;
      var frames = [[0, 50], [600, 24], [1300, 78], [2000, 50]];
      frames.forEach(function (f) { setTimeout(function () { animateTo(f[1]); }, f[0]); });
    }
    var raf = null;
    function animateTo(target) {
      var start = parseFloat(getComputedStyle(root).getPropertyValue('--ad-split')) || 50;
      var t0 = null, dur = 520;
      cancelAnimationFrame(raf);
      function tick(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min(1, (ts - t0) / dur);
        var e = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
        set(start + (target - start) * e);
        if (p < 1) raf = requestAnimationFrame(tick);
      }
      raf = requestAnimationFrame(tick);
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) { sweep(); io.disconnect(); } });
      }, { threshold: 0.45 });
      io.observe(root);
    }
    set(50);
  }

  /* ---- mobile buy bar: up once the hero CTA has gone, down over the buy blocks ---- */
  function stickyBar() {
    var bar = document.querySelector('[data-ad-sticky]');
    if (!bar || !('IntersectionObserver' in window)) return;
    var trigger = document.querySelector('[data-ad-sticky-trigger]');
    var hiders = document.querySelectorAll('[data-ad-sticky-hide]');
    var pastTrigger = false, overHider = false;

    function apply() { bar.classList.toggle('is-up', pastTrigger && !overHider); }

    if (trigger) {
      new IntersectionObserver(function (en) {
        en.forEach(function (e) { pastTrigger = !e.isIntersecting && e.boundingClientRect.top < 0; apply(); });
      }, { threshold: 0 }).observe(trigger);
    } else { pastTrigger = true; }

    if (hiders.length) {
      var seen = new Set();
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (e) { if (e.isIntersecting) seen.add(e.target); else seen.delete(e.target); });
        overHider = seen.size > 0;
        apply();
      }, { threshold: 0.12 });
      Array.prototype.forEach.call(hiders, function (el) { io.observe(el); });
    }
    apply();
  }

  /* ---- one custom event when the product tiles are first seen ---- */
  function tilesEvent() {
    var block = document.querySelector('[data-ad-tiles]');
    if (!block || !('IntersectionObserver' in window)) return;
    var variant = block.getAttribute('data-ad-variant') || '';
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('lp_set_block_viewed', { page_variant: variant });
          }
          document.dispatchEvent(new CustomEvent('lp_set_block_viewed', { detail: { page_variant: variant } }));
        } catch (err) { /* analytics must never break the page */ }
      });
    }, { threshold: 0.35 });
    io.observe(block);
  }

  /* ---- one lp_section_viewed event per section, the first time it is seen ---- */
  function sectionEvents() {
    var secs = document.querySelectorAll('[data-ad-section]');
    if (!secs.length || !('IntersectionObserver' in window)) return;
    var body = document.body;
    var variant = body.getAttribute('data-ad-variant') || '';
    var entry = body.getAttribute('data-ad-entry') || '';
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        var payload = { page_variant: variant, entry: entry, section: e.target.getAttribute('data-ad-section') };
        try {
          if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
            Shopify.analytics.publish('lp_section_viewed', payload);
          }
          document.dispatchEvent(new CustomEvent('lp_section_viewed', { detail: payload }));
        } catch (err) { /* analytics must never break the page */ }
      });
    }, { threshold: 0.25 });
    Array.prototype.forEach.call(secs, function (el) { io.observe(el); });
  }

  /* ---- founder video: opens full screen, closes back where it was ---- */
  function videoPlayer() {
    var open = document.querySelector('[data-ad-video-open]');
    var modal = document.querySelector('[data-ad-video-modal]');
    if (!open || !modal) return;
    var video = modal.querySelector('video');
    var bar = document.querySelector('[data-ad-sticky]');
    var played = false, completed = false;
    var variant = document.body.getAttribute('data-ad-variant') || '';

    function publish(name) {
      try {
        if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
          Shopify.analytics.publish(name, { page_variant: variant });
        }
        document.dispatchEvent(new CustomEvent(name, { detail: { page_variant: variant } }));
      } catch (err) { /* analytics must never break the page */ }
    }
    function show() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      if (bar) bar.classList.add('is-hidden-for-video');
      if (video) { video.play().catch(function () {}); }
      var close = modal.querySelector('[data-ad-video-close]');
      if (close) close.focus();
    }
    function hide() {
      modal.hidden = true;
      document.body.style.overflow = '';
      if (bar) bar.classList.remove('is-hidden-for-video');
      if (video) video.pause();
      open.focus();
    }
    open.addEventListener('click', show);
    Array.prototype.forEach.call(modal.querySelectorAll('[data-ad-video-close]'), function (el) {
      el.addEventListener('click', hide);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) hide(); });
    if (video) {
      video.addEventListener('play', function () { if (!played) { played = true; publish('lp_video_play'); } });
      video.addEventListener('timeupdate', function () {
        if (!completed && video.duration && video.currentTime / video.duration >= 0.9) {
          completed = true; publish('lp_video_complete');
        }
      });
    }
  }

  function init() {
    reveal();
    videoPlayer();
    sectionEvents();
    Array.prototype.forEach.call(document.querySelectorAll('.ad-compare'), compare);
    stickyBar();
    tilesEvent();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
